// extracted by css-extract-rspack-plugin
export default {"modalFooter":"DeleteUser__modalFooter--A6_Rb","footerButton":"DeleteUser__footerButton--xIfZC"};